import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import Slider from 'react-slick';
import { all_routes } from '../../../router/all_routes';

const Categories = () => {

    const categoriesslider = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const route = all_routes;
    
    return (
        <>
            {/* Course Categories Five */}
            <section className="course-section-five">
                <div className="container">
                    <div className="header-five-title text-center" data-aos="fade-down">
                        <h2>Field of Study</h2>
                        <p>
                            Explore top study areas and choose from 1,500+ programs across the world’s leading institutions.
                        </p>
                    </div>
                    <Slider {...categoriesslider}>
                        {/* Carousel Item */}
                        <Link
                            to={`${route.allProgramsGrid}?field=science`}
                            className="categories-item categories-item-six"
                            data-aos="fade-down"
                        >
                            <div className="categories-icon">
                                <div className="icon-bg">
                                    <ImageWithBasePath src="assets/img/icon/field-01.svg" alt="Img" />
                                </div>
                            </div>
                            <h3 className="title">
                                Sciences
                            </h3>
                            <div className="view-icon">
                                <i className="fas fa-chevron-right" />
                            </div>
                        </Link>
                        {/* /Carousel Item  */}
                        {/* Carousel Item  */}
                        <Link
                            to={`${route.allProgramsGrid}?field=tech`}
                            className="categories-item categories-item-six"
                            data-aos="fade-down"
                        >
                            <div className="categories-icon">
                                <div className="icon-bg">
                                    <ImageWithBasePath src="assets/img/icon/field-02.svg" alt="Img" />
                                </div>
                            </div>
                            <h3 className="title">
                                Engineering
                            </h3>
                            <div className="view-icon">
                                <i className="fas fa-chevron-right" />
                            </div>
                        </Link>
                        {/* /Carousel Item  */}
                        {/* Carousel Item  */}
                        <Link
                            to={`${route.allProgramsGrid}?field=tech`}
                            className="categories-item categories-item-six"
                            data-aos="fade-down"
                        >
                            <div className="categories-icon">
                                <div className="icon-bg">
                                    <ImageWithBasePath src="assets/img/icon/field-03.svg" alt="Img" />
                                </div>
                            </div>
                            <h3 className="title">
                                Technology
                            </h3>
                            <div className="view-icon">
                                <i className="fas fa-chevron-right" />
                            </div>
                        </Link>
                        {/* /Carousel Item  */}
                        {/* Carousel Item  */}
                        <Link
                            to={`${route.allProgramsGrid}?field=arts`}
                            className="categories-item categories-item-six"
                            data-aos="fade-down"
                        >
                            <div className="categories-icon">
                                <div className="icon-bg">
                                    <ImageWithBasePath src="assets/img/icon/field-04.svg" alt="Img" />
                                </div>
                            </div>
                            <h3 className="title">
                                Arts
                            </h3>
                            <div className="view-icon">
                                <i className="fas fa-chevron-right" />
                            </div>
                        </Link>
                        {/* /Carousel Item  */}
                        {/* Carousel Item */}
                        <Link
                            to={`${route.allProgramsGrid}?field=business`}
                            className="categories-item categories-item-six"
                            data-aos="fade-down"
                        >
                            <div className="categories-icon">
                                <div className="icon-bg">
                                    <ImageWithBasePath src="assets/img/icon/field-05.svg" alt="Img" />
                                </div>
                            </div>
                            <h3 className="title">
                                Business
                            </h3>
                            <div className="view-icon">
                                <i className="fas fa-chevron-right" />
                            </div>
                        </Link>
                        {/* /Carousel Item  */}
                        {/* Carousel Item  */}
                        <Link
                            to={`${route.allProgramsGrid}?field=medicine`}
                            className="categories-item categories-item-six"
                            data-aos="fade-down"
                        >
                            <div className="categories-icon">
                                <div className="icon-bg">
                                    <ImageWithBasePath src="assets/img/icon/field-06.svg" alt="Img" />
                                </div>
                            </div>
                            <h3 className="title">
                                Medicine
                            </h3>
                            <div className="view-icon">
                                <i className="fas fa-chevron-right" />
                            </div>
                        </Link>
                        {/* /Carousel Item  */}
                    </Slider>
                </div>
            </section>
            {/* /Course Categories Five*/}
        </>

    )
}

export default Categories
